import { gql } from "@apollo/client";

export const DOCUMENT_CHAT_HISTORY_MUTATION = gql`
  mutation DocumentChatHistory($input: DocumentChatHistoryInput!) {
    documentChatHistory(input: $input) {
      messages {
        role
        message
      }
      sessionId
      success
      message
    }
  }
`;

export const DOCUMENT_ASSISTANT_MUTATION = gql`
  mutation DocumentAssistant($input: DocumentAssistantInput!) {
    documentAssistant(input: $input) {
      data
        success
        message
        sessionId
        refresh
    }
  }
`;

export const REMOVE_DOCUMENT_HISTORY_MUTATION = gql`
  mutation RemoveDocumentHistory($input: RemoveDocumentHistoryInput!) {
    removeDocumentHistory(input: $input) {
      success
      message
    }
  }
`;

export const SAVE_INSTRUCTION_MUTATION = gql`
  mutation SaveInstruction($input: SaveInstructionInput!) {
    saveInstruction(input: $input) {
      totalProcessed
      totalSuccessful
      totalFailed
    }
  }
`;

export const VALIDATION_COVERAGE_MUTATION = gql`
  mutation ValidationCoverage($input: ValidationCoverageInput!) {
    validationCoverage(input: $input) {
      coverage
      information
      prompt
      success
      message
    }
  }
`;

export const SAVE_CONVERSATION_MUTATION = gql`
  mutation SaveConversation($input: SaveConversationInput!) {
    saveConversation(input: $input) {
      id
      title
      summary
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

// Incident Assistant Mutations — these route through the dedicated
// `incidentChat` / `incidentConversations` resolvers which hit the Python
// assistants service (ONBOARDING_SERVICE_URL), NOT the Node assistants
// service on port 3005.

export const INCIDENT_CHAT_MUTATION = gql`
  mutation IncidentChat($input: IncidentChatInput!) {
    incidentChat(input: $input) {
      success
      message
      response
      conversationId
      timeStamp
    }
  }
`;

export const INCIDENT_CONVERSATIONS_MUTATION = gql`
  mutation IncidentConversations {
    incidentConversations {
      success
      message
      conversations {
        role
        message
        timeStamp
      }
      conversationId
    }
  }
`;

export const RESET_INCIDENT_CONVERSATION_MUTATION = gql`
  mutation ResetIncidentConversation {
    resetIncidentConversation {
      success
      message
    }
  }
`;

// Facility Onboarding Mutation
